var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExclamation = function SvgExclamation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M64 6c32.033 0 58 25.967 58 58s-25.967 58-58 58S6 96.033 6 64 31.967 6 64 6m.549 82.103q-4.177 0-6.363 2.137T56 96.55q0 4.026 2.234 6.237t6.315 2.212q3.982 0 6.217-2.261Q73 100.478 73 96.55q0-4.075-2.21-6.262t-6.241-2.186ZM73 23H56.194l2.477 48.555h11.852z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExclamation);
export default ForwardRef;